/** ID опции атрибута label в Magento для ярлыка «Новинка» */
export const NEW_PRODUCT_LABEL_VALUE = '348';

const REVIEW_BONUS_POINTS = {
  text: { regular: 50, newProduct: 100 },
  photo: { regular: 100, newProduct: 200 }
} as const;

export type ReviewBonusPoints = {
  text: number;
  photo: number;
};

/** Баллы за отзыв в зависимости от статуса товара */
export const utilGetReviewBonusPoints = (
  isNewProduct = false
): ReviewBonusPoints => ({
  text: isNewProduct
    ? REVIEW_BONUS_POINTS.text.newProduct
    : REVIEW_BONUS_POINTS.text.regular,
  photo: isNewProduct
    ? REVIEW_BONUS_POINTS.photo.newProduct
    : REVIEW_BONUS_POINTS.photo.regular
});

/** Проверяет, является ли товар новинкой по value ярлыка label в Magento */
export const utilIsNewProductByLabels = (
  labels: { value?: string }[] = []
): boolean => labels.some((label) => label.value === NEW_PRODUCT_LABEL_VALUE);
